module.exports = __webpack_public_path__ + "static/background-9621e861c41fa0d4b23955a568a93b3e.svg";